export const PROFILE = {
  ADD: "add",
  ACTIVE_STATUS: 4,
  ADD_ONE: 1,
  ACCORDION_DEFAULT_VALUE: "1",
  ACCOUNT_FORM: 4,
  ADD_FORM_KEY: "AddForm",
  ADDITIONAL_SKILLS: "additionalSkills",
  BILL_DETAILS_FORM: 1,
  CITY_KEY: "city",
  CONTACT_FORM: 2,
  CONTACT_TYPE: "4",
  DECIMAL_REGEX: /^[0-9.]$/,
  APPROVED: 4,
  COMPLETED_PROGRESS: 100,
  CUSTOM_ERROR: "custom",
  DECREMENT_ONE: 1,
  DEFAULT_CONTACT_ROLE: "2",
  EXPERIENCE: "experience",
  EXPERT: 2,
  EXPIRATION_DATE: "expirationDate",
  FIELD_KEY: 2,
  FIRST_ITEM: 1,
  GOOGLE_REFERRAL: "google_referral",
  HOW_MANY_PRACTICE_DEFAULT_VALUE: "0",
  HYGIENIST_UUID: "fbb69fd4-ec48-4bc6-82e7-42eaf9ffd8d7",
  IDENTIFICATION_FORM: 2,
  ID_KEY: 1,
  IN_REVIEW: 3,
  LICENSE: "license",
  LICENSE_FORM: 1,
  LICENSE_NUMBER: "licenseNumber",
  MOBILE_NUMBER_REGEX: /^[0-9+]*$/,
  MODERATE: 1,
  NEW_FORM: "0",
  NOVICE: 0,
  NPI_NUMBER: "npiNumber",
  NUMBER_REGEX: /^\d*$/,
  OFFICE_INFORMATION_FORM: 0,
  OFFICE_APPROVED: "4",
  OFFICE_KEY: "office",
  OFFICE_NUMBER_REGEX: /^([0-9()-+ ]|Backspace){0,15}$/,
  OFFICE_TYPE: "1",
  OTHER_ID: "others",
  PERSONAL_DETAILS: 0,
  PRACTICE_FORM: 3,
  PRIMARY_ROLE: "primaryRole",
  PRIMARY_SKILLS: "primarySkills",
  PROFESSIONAL_KEY: "professional",
  PROFESSIONAL_TYPE: "2",
  PROPHY_TIME: "prophyTime",
  OTHER: "other",
  OTHER_CHECKBOX: "others",
  NO: "0",
  NOT_VALUE: "undefined",
  ROLE: "role",
  SECONDARY_ROLE: "secondaryRole",
  SEND_ALERT: "sendAlert",
  SKILL_FORM: 5,
  SPECIALITY_SKILL: "speciality_skill",
  SPECIALITY_SKILLS: "specialitySkills",
  SOFTWARE_EXPERIENCE: "software_experience",
  SOFTWARE_SKILL: "softwareSkill",
  SOFTWARE_FORM: 4,
  TIME_SPLIT: "T",
  TWO_ITEMS: 2,
  UNDERSCORE: "_",
  UPDATE_PASSWORD_KEY: "Update Password",
  WORK_HISTORY_FORM: 3,
  YES: "1",
  No: "0",
  NUMBER_TWO: "2",
  DOB: "dob",
};
